<div class="wrapper" [style.height.px]="height">
  @if (navigator.selectedNav !== 'Login') {
    <header class="headerBar">
      <div class="backHeader">
        @if (navigator.canGoBack) {
          <button
            class="headerBtn"
            (click)="back()"
            [disabled]="backPending || actionsDisabled"
            >
            <img class="backIcon" src="assets/arrow_back.svg" />
          </button>
        }
      </div>
      <div class="notranslate">
        <div class="titleHeader">
          <div class="headerTitle">{{ navigator.selectedTitle }}</div>
        </div>
      </div>
      <div class="logoutHeader">
        <button
          class="headerBtn"
          (click)="logout()"
          class="headerBtn"
          [disabled]="actionsDisabled"
          >
          <img class="backIcon" src="assets/logout.svg" />
        </button>
      </div>
    </header>
  }
  @if (navigator.selectedNav === 'Login') {
    <app-login
      class="loginWrapper"
    ></app-login>
  }
  @if (navigator.selectedNav === 'Menu') {
    <app-operating-mode-menu
      class="ctDeviceWrapper"
    ></app-operating-mode-menu>
  }
  @if (navigator.selectedNav === 'ContainerFlash') {
    <app-container-flash
      class="ctDeviceWrapper"
    ></app-container-flash>
  }
  @if (navigator.selectedNav === 'DeviceFlash') {
    <app-device-flash
      class="ctDeviceWrapper"
    ></app-device-flash>
  }
  @if (navigator.selectedNav === 'Inventory') {
    <app-inventory
      class="ctDeviceWrapper"
    ></app-inventory>
  }
</div>

<router-outlet></router-outlet>
